<template>
  <div ref="whole_page">
    <vx-card id="site-course-card" title="Site & Course" class="w-full mb-6">
      <div>
        <div v-if="selectedSite" class="mb-4 breadcrums" >
          
        </div>
        <div v-if="selectedCourse.id == 0">
          <div class="vx-row">
            <div class="vx-col  w-full">
              <div class="mb-3">
                <h5>Select Site</h5>
                <v-select ref="SiteDropDown" placeholder="Search / Select Site" :options="siteList" v-model="selectedSite"></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row w-full" >
        <div v-if="selectedSite && selectedCourse.id == 0" class="vx-col w-full">
          <vx-card class="w-full pathCard" title="Select a Course" id="courseOutcomeCard" ref="courseOutcome">        
            <vs-table stripe ref="courseOutcomeTable" class="vs-con-loading__container" single @selected="getModule" pagination max-items="10" search :data="courseList"> 
              <template slot="thead">
                <vs-th sort-key="text">Name</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data">

                  <vs-td :data="data[indextr].text">
                    {{ course.text }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              v-if="courseList.length"
              @click="initCourse"
              icon-pack="feather"
              icon="icon-arrow-left"
              color = "warning">
              Cancel
            </vs-button>
          </vx-card>
        </div>
        <div v-if="selectedCourse.id != 0 && selectedModule.id == 0" class="vx-col w-full">
          <vx-card class="w-full pathCard" title="Select a Module" id="moduleOutcomeCard" ref="moduleOutcome">
            <vs-table stripe ref="moduleOutcomeTable" class="vs-con-loading__container semiPathCard" single @selected="loadTaskGroup" pagination max-items="10" search :data="moduleList"> 
              <template slot="thead">
                <vs-th sort-key="name">Name</vs-th>
                <vs-th sort-key="learningStyleB">Style Type</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="courseModule" :key="indextr" v-for="(courseModule, indextr) in data" >

                  <vs-td :data="data[indextr].name">
                    {{ courseModule.name }}
                  </vs-td>

                  <vs-td :data="data[indextr].learningStyleB">
                    {{ courseModule.learningStyleB? "Module Based" : "Story Based"}}
                  </vs-td>
                  
                  <vs-td>
                    <vs-button color="success" @click.stop.prevent="generateShortCourse(courseModule)" icon-pack="feather" icon="icon-corner-down-right" >Generate</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              @click="cancelCourse"
              icon-pack="feather"
              icon="icon-arrow-left"
              color = "warning">
              Back
            </vs-button>
          </vx-card>
        </div>

        <div v-if="selectedModule.id != 0 && selectedTaskGroup.id == 0" class="vx-col w-full">
          <vx-card class="w-full pathCard" title="Select a Task Group" id="taskGroupTableCard" ref="taskGroupTableCard">        
            <vs-table stripe ref="taskGroupTable" class="vs-con-loading__container semiPathCard" single @selected="loadOutcomes" pagination  max-items="10" search :data="taskGroupList"> 
              <template slot="thead">
                <vs-th sort-key="name">Name</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="taskGroup" :key="indextr" v-for="(taskGroup, indextr) in data" >

                  <vs-td :data="data[indextr].name" class="w-1/2">
                    {{ taskGroup.name }}
                  </vs-td>
                  
                  <vs-td>
                    <vs-button color="success" icon-pack="feather" icon="icon-corner-down-right" @click.stop.prevent="generateShortCourseFromTaskGroup(taskGroup)">Generate</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              @click="cancelModule"
              icon-pack="feather"
              icon="icon-arrow-left"
              type="filled"
              color = "warning">
              Back
            </vs-button>
          </vx-card>
        </div>

        <div v-if="selectedTaskGroup.id != 0" class="vx-col w-full">
          <vx-card class="w-full pathCard" title="Select an Outcome" id="outcomeGroupCard" ref="outcomeGroupCard">        
            <vs-table stripe ref="outcomeGroupTable" class="vs-con-loading__container semiPathCard" single pagination  max-items="10" search :data="outcomeList"> 
              <template slot="thead">
                <vs-th sort-key="name">Name</vs-th>
                <vs-th sort-key="numberTasks">Tasks</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="outcome" :key="indextr" v-for="(outcome, indextr) in data" >

                  <vs-td :data="data[indextr].name" class="w-1/3">
                    {{ outcome.name }}
                  </vs-td>
                  <vs-td :data="data[indextr].numberTasks" class="w-1/3">
                    {{ outcome.numberTasks }}
                  </vs-td>
                  
                  <vs-td class="w-1/3">
                    <vs-button color="success" icon-pack="feather" icon="icon-corner-down-right" @click.stop.prevent="generateShortCourseFromOutcome(outcome)">Generate</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              @click="cancelTaskGroup"
              icon-pack="feather"
              icon="icon-arrow-left"
              type="filled"
              color = "warning">
              Back
            </vs-button>
          </vx-card>
        </div>

      </div>
      <vs-button
      v-if="selectedModule.id && false"
        @click="cancelSite"
        class="school-primary_gradient glow-effect_tertiary mt-4">
        Convert to short course
      </vs-button>
    </vx-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components:{
      vSelect
    },
    data() {
      return {
        selectedSite:null,
        siteList: [],
        courseList: [],
        moduleList: [],
        taskGroupList: [],
        outcomeList: [],
        itemsPerPage: 6,
        selectedCourse:{
          name:"",
          id:0,
        },
        selectedModule:{
          name:"",
          id:0,
        },
        selectedTaskGroup:{
          name:"",
          id:0,
        },
        selectedOutcome:{
          name:"",
          id:0,
        },
      }
    },
    watch: {
      selectedSite :function() {
        var self = this;
        if(self.selectedSite){
          self.handleSelectedGetCourse(self.selectedSite.value);
          return
        }
        self.clearSelectedSite();
      }
    },
    computed: {

    },
    methods: {
      initValues(){
        this.selectedSite = null;
        this.siteList = [];
        this.initCourse();
        this.moduleList = [];
        this.taskGroupList = [];
        this.itemsPerPage = 6;
        this.courseList = [];
        this.outcomeList = [];
        this.selectedCourse.name = "";
        this.selectedCourse.id = 0;

        this.selectedModule.name = "";
        this.selectedModule.id = 0;

        this.selectedTaskGroup.name = "";
        this.selectedTaskGroup.id = 0;

        this.selectedOutcome.name = "";
        this.selectedOutcome.id = 0;
      },
      clearSelectedSite(){
        this.selectedSite = null;
        this.initCourse();
        this.moduleList = [];
        this.itemsPerPage = 6;
        
        this.courseList = [];
        this.selectedCourse.name = "";
        this.selectedCourse.id = 0;

        this.selectedModule.name = "";
        this.selectedModule.id = 0;

        this.selectedTaskGroup.name = "";
        this.selectedTaskGroup.id = 0;

        this.selectedOutcome.name = "";
        this.selectedOutcome.id = 0;

      },
      initCourse(){
        this.selectedSite = null;
        this.courseList = [];
        this.selectedCourse.name = "";
        this.selectedCourse.id = 0;
      },
      getSite(){
        var self = this;
        self.showLoadingOnElement("SiteDropDown",0.45,"corners");
        var onSuccess = response =>{
          self.siteList =  response.data.map(function(item) {return {value: item.value,label: item.text}});
        }
      
        var onFinally = response =>{
          if(self.$refs.SiteDropDown){
            self.$vs.loading.close(self.$refs.SiteDropDown.$el);
          }
        }
      
        self.$ajaxGet(self, "Site/GetAllsites" , onSuccess, onFinally);
      },
      handleSelectedGetCourse(siteId) {
        var self = this;
        self.showLoadingOnElement("whole_page", 1, "corners");
        var onSuccess = function (response) {
          self.courseList = response.data;
        };
        var onFinally = function () {
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        };

        self.$ajaxGet(self, "Course/GetAllCourses?siteId=" + siteId, onSuccess, onFinally);
      },
      getModule(course) {
        var self = this;
        self.showLoadingOnElement("whole_page", 1, "corners");
        self.selectedCourse.id = parseInt(course.value);
        self.selectedCourse.name = course.text;
        var onSuccess = function (response) {
          self.moduleList = response.data;
          if(self.$refs.moduleOutcomeTable){
            self.$refs.moduleOutcomeTable.currentx = 1;
          }
        };
        var onFinally = function () {
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        };

        self.$ajaxGet(self, "Module/GetAllModule?courseId=" + course.value, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      cancelSite(){
        var self = this;
        self.siteName = "";
        self.courseList = [];
        self.courseName = "";
        self.moduleList = [];
        self.selectedModule.name = "";
        self.selectedModule.id = 0;

      },
      cancelCourse(){
        var self = this;
        this.selectedCourse.name = "";
        this.selectedCourse.id = 0;

        this.selectedModule.name = "";
        this.selectedModule.id = 0;

        this.selectedTaskGroup.name = "";
        this.selectedTaskGroup.id = 0;

        this.selectedOutcome.name = "";
        this.selectedOutcome.id = 0;
      },
      cancelModule(){
        var self = this;

        this.selectedModule.name = "";
        this.selectedModule.id = 0;

        this.selectedTaskGroup.name = "";
        this.selectedTaskGroup.id = 0;

        this.selectedOutcome.name = "";
        this.selectedOutcome.id = 0;
      },
      cancelTaskGroup(){
        var self = this;

        this.selectedTaskGroup.name = "";
        this.selectedTaskGroup.id = 0;

        this.selectedOutcome.name = "";
        this.selectedOutcome.id = 0;
      },
      loadTaskGroup(moduleData){
        var self = this;
        if(!moduleData.learningStyleB){
          return
        }
        self.showLoadingOnElement("whole_page",1,"corners");
        self.selectedModule.id = moduleData.id;
        self.selectedModule.name = moduleData.name;

        var onSuccess = response =>{
          self.taskGroupList = response.data;
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `TaskGroup/GetSelectedModule?moduleId=${moduleData.id}` , onSuccess, onFinally);
      },
      loadOutcomes(taskGroupSelected){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");
        self.selectedTaskGroup.id = taskGroupSelected.id;
        self.selectedTaskGroup.name = taskGroupSelected.name;

        var onSuccess = response =>{
          self.outcomeList = response.data;
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `CourseOutcomes/GetSelectedModule?TaskGroupId=${taskGroupSelected.id}` , onSuccess, onFinally);
      },
      generateShortCourse(moduleData){
        var self = this;
        self.$router.push({ name: 'ShortCourses', params: { moduleData: moduleData }}); 
      },
      generateShortCourseFromTaskGroup(taskGroup) {
        this.$router.push({ name: 'ShortCourses', params: { moduleData: this.selectedModule, taskGroupData: taskGroup}}); 
      },
      generateShortCourseFromOutcome(outcome) {
        this.$router.push({ name: 'ShortCourses', params: { moduleData: this.selectedModule, taskGroupData: this.selectedTaskGroup, outcomeData: outcome}}); 
      }
    },
    mounted() {
      var self = this;
      self.getSite();
    },
  }

</script>
<style lang="scss">
  .align-multiline-content {
    display: flex;
    align-items: center;
  }
  .back_button-item {
    padding-left: 0 !important;
    font-size: 13pt !important;
    font-weight: 100 !important;
  }
</style>
